import { useFormContext } from "react-hook-form";

export function useUnsafeFormContext() {
	try {
		return useFormContext();
	} catch {
		return null;
	}
}
